import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { CAMPAIGN_REDIRECT_FALLBACK_STORAGE_KEY } from '../login-dialog/login.service';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    private router: Router,
    private appService: AppService,
  ) {}

  ngOnInit() {
    const hasFallBackParam = sessionStorage.getItem(CAMPAIGN_REDIRECT_FALLBACK_STORAGE_KEY) === 'home';
    if (hasFallBackParam) {
      sessionStorage.removeItem(CAMPAIGN_REDIRECT_FALLBACK_STORAGE_KEY);
      this.router.navigateByUrl(`/${this.appService.languageCode}`, { replaceUrl: true });
    }
  }

  goHome() {
    this.router.navigate(['']);
  }
}
